const destroy = function destroyAccount() {};

const init = function initAccount() {
  const { pathname } = window.location;
  const link = document.querySelector('.js-accountLink');
  if (!link || pathname.indexOf('/account/activate/') === 0) {
    return;
  }

  // Navigate to ReCharge
  window.location = link.getAttribute('href');
};

export default {
  destroy,
  init,
};
